import { memo, ReactNode } from 'react';
import classNames from 'classnames';
import css from './ButtonList.module.scss';
import { ButtonGroupProps } from './ButtonGroup.types';

/**
 * A grouping component to render an array of buttons with specified alignment and styling.
 *
 * @param className - {@link ButtonGroupProps.className className} description.
 * @param alignment - {@link ButtonGroupProps.alignment alignment} description. (default: `'right'`)
 * @param buttons - {@link ButtonGroupProps.buttons buttons} description.
 */
const ButtonGroup = memo(({
    className,
    alignment = 'right',
    buttons,
}: ButtonGroupProps) => {
    return (
        <div
            role={'group'}
            className={classNames(css.buttonList, css[alignment], className)}
        >
            {buttons.map((button: ReactNode, index: number) => {
                return (
                    !!button ? (
                        <div
                            role={'presentation'}
                            key={`ButtonGroup-button-${index}`}
                            className={css.button}
                        >
                            {button}
                        </div>
                    ) : null
                );
            })}
        </div>
    );

});

export default ButtonGroup;
